export default __webpack_public_path__ + "static/media/AG4.2c1a8d8a.jpg";